import * as Yup from 'yup'

export const budgetValidationRules = Yup.object().shape({
  budget: Yup.number().required('Budget is required'),
  date_from: Yup.string().required('start Date is required'),
  date_to: Yup.string().required('end Date is required')
});